<template>
  <app-modal-prompt
      v-model="value"
      @confirm="confirm"
      @cancel="$emit('cancel')"
      :persistent="persistent"
  >
    <template #title>
      Conectar con {{ pathLabel }}
    </template>
    <app-modal-container v-if="showMailField">
      <app-modal-row
          class="justify-center text-center app-confirm-modal__body mb-10"
      >
        Introducir el email con el que va a acceder a su cuenta de {{ pathLabel }}.
      </app-modal-row>
      <v-form ref="dropboxTeamForm">
        <app-modal-row class="mb-2">
          <app-modal-col cols="12">
            <app-text-field
                v-model="email"
                label="Email"
                prepend-inner-icon="mdi-email-outline"
                :rules="[validationRules.emailFormat, validationRules.required]"
                type="text"
            />
          </app-modal-col>
        </app-modal-row>
      </v-form>
    </app-modal-container>
  </app-modal-prompt>
</template>
<script>
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppTextField from "@/components/layout/AppTextField.vue";
import AppModalPrompt from "@/components/layout/AppModalPrompt.vue";

export default {
  name: 'OauthPrompt',
  components: {
    AppModalPrompt,
    AppModalCol,
    AppModalContainer,
    AppModalRow,
    AppTextField,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    textMsg: {
      type: String,
      default: ''
    },
    pathLabel: {
      type: String,
      default: ''
    },
    showMailField: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      email: '',
      validationRules: {
        required: v => !!v || 'Campo obligatorio',
        emailFormat: v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El formato del email no es válido',
      }
    }
  },
  methods: {
    confirm() {
      if (this.showMailField) {
        const formIsValid = this.$refs.dropboxTeamForm.validate();
        if (!formIsValid) {
          return;
        }
      }
      this.$emit('confirm', this.email);
    }
  }
}
</script>

<style scoped>
.app-confirm-modal__body {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 20px;
  line-height: 23px;
  font-weight: 400;
}
</style>